import { useState } from "preact/hooks";
import { hydrate } from "@reactive/lib";

/*
* Example Preact Fragment for highly dynamic components
* */
interface HelloWorldProps extends Props {
    title: string,
    subtitle: string
}


function HelloWorldComponent(props: HelloWorldProps) {
    const [count, setCount] = useState(0);
    const { title, subtitle } = props;
    console.log(props);

    return (
        <>
            <h1>Reactive Hello World!</h1>
            <div className="card">
                <h2>You can implement reactive components using this boilerplate.</h2>
                <button onClick={() => setCount((count) => count + 1)}>count is {count}</button>
                <br />
                {title}, {subtitle}
            </div>
        </>
    );
}

//@ts-ignore
export function HelloWorld(props: HelloWorldProps) {
    hydrate(<HelloWorldComponent {...props}/>, props.targets);
}
